import { Component, OnInit,Input, NgZone,Inject, Output, EventEmitter } from '@angular/core';
import { I18nService } from 'core-app/modules/common/i18n/i18n.service';
import { DocumentsService } from '../../services/check.lists.service';
import { HttpClient } from '@angular/common/http';

declare let layui:any


@Component({
  selector: 'my_action',
  templateUrl: './my_action.component.html',
  styleUrls: ['./my_action.component.sass']
})
export class MyActionComponent implements OnInit{
  @Output() clicklistid = new EventEmitter();
  public fileRefNo:any
  public kind_id:any
  public type:any='RISC(inspection)'
  public page:any=1
  public per_page:any=10

  public projectId:any = document.getElementsByName('current_project')[0].dataset.projectId
  public listType:any = [
    {
        name:'RISC(Work)',
        type:'RISC(inspection)',
        typeName:'risc_work',
        num:0,
        url:'risc_list'
    },
    {
        name:'RISC(survey)',
        type:'RISC',
        typeName:'risc_survey',
        num:0,
        url:'risc_list'
    },
    {
        name:'RISC(E&M)',
        type:'RISC(E&M)',
        typeName:'risc_em',
        num:0,
        url:'risc_list'
    },
    {
        name:'Site Diary',
        type:'site_diary',
        typeName:'site_diary',
        num:0,
        url:'site_diary'
    },
    {
        name:'Daily Cleansing',
        type:'daily_cleaning',
        typeName:'daily_cleaning',
        num:0
    },
    {
        name:'Weeky Tidying',
        type:'weekly_tidying',
        typeName:'weekly_tidying',
        num:0
    },
    {
        name:'Weekly Environmental Walk Inspection',
        type:'weekly_environmental',
        typeName:'weekly_environmental',
        num:0
    },
    {
        name:'Weekly Safety',
        type:'weekly_safety',
        typeName:'weekly_safety',
        num:0
    },
    {
        name:'Labour Return 2003',
        type:'labour_returns_v03',
        typeName:'labour_returns_v03',
        num:0
    },
    {
        name:'Labour Return 2017',
        type:'labour_returns_v17',
        typeName:'labour_returns_v17',
        num:0
    },
    {
        name:'Monthly Safety',
        type:'monthly_safety',
        typeName:'monthly_safety',
        num:0
    },
    {
        name:'Confined Space Works',
        type:'confined_space_works',
        typeName:'confined_space_works',
        num:0
    },
  ]
  public url:any = 'risc_list'
  public list:any = []
  public total:any=0
  public isInit:any = true
  public embeddedObj:any = {}
  public isShowActive:any = false
  public ActiveName:string = ''
  public titleTime =''
  public isShowType:any
  //右键菜单X轴
  public itemX: string;
  //右键菜单Y轴
  public itemY: string;
  //右键菜单id
  public rightID: string;
  //右键菜单状态
  public rightState: string;
  constructor(public service: DocumentsService,
    @Inject('DAYJS') private dayjs:any,
    private http: HttpClient,
    private zone: NgZone,
    public i18n: I18nService,) { }

  ngOnInit() {
    this.getData()
    this.getlistTypeNum()

    // 点击页面其他地方隐藏右键菜单
    jQuery('#content-wrapper').css({'background':'#ffffff','padding': "15px"});
    jQuery(document).bind('click', function(e:any) {
      var e = e || window.event; //浏览器兼容性
      var elem:any = e.target || e.srcElement;
      while (elem) { //循环判断至跟节点，防止点击的是div子元素
          if (elem.id && elem.id == 'myActionMenu') {
              return;
          }
          elem = elem.parentNode;
      }
      jQuery('#myActionMenu').css('visibility', 'hidden'); //点击的不是div或其子元素
    });
  }
  updateList(event:any){
    this.getlistTypeNum()
    this.getData()
  }
      //显示合同签署人
    showHandler(item:any){
      const handler:any = {
        sent:'contractor_signer',
        pending_review:'supervisor_signer'
      }
      if(!item[handler[item.state]]){
        return ''
      }
      return item[handler[item.state]].name 
    }
  getData (){
    const checkListType = ['daily_cleaning','weekly_tidying','weekly_environmental','weekly_safety','monthly_safety','confined_space_works']
    const labourReturnType = ['labour_returns_v03','labour_returns_v17']
    if(labourReturnType.includes(this.type)){
      const version = this.type == 'labour_returns_v03' ? 'v03' : 'v17'
       this.http.get(`/api/v3/projects/${this.projectId}/labour_returns?project_id=${this.projectId}&action=my_action&version=${version}&order_way=month`)
        .subscribe((res:any)=>{
          this.list = res.list
          this.isShowType = 4
          this.total = res.total_count
          if(this.isInit){
              this.initPage()
              this.isInit = false
          }
        })
    }else if(checkListType.includes(this.type)){
    const  checkListMap:any = {
        'daily_cleaning': '2',
        'weekly_tidying': '3',
        'weekly_environmental': '4',
        'weekly_safety': '7',
        'confined_space_works':'12',
        'monthly_safety': '6'
      }
      console.log(checkListMap[this.type],'检查类型');
      let data = {
        kind_id: checkListMap[this.type],
        type: this.type,
        page: this.page,
        per:this.per_page,
        by_action:'MyAction'
      }
    this.service.checklistsindex(this.projectId,data,'desc').subscribe((res:any)=>{
        console.log(res,'数据');
            this.list = []
            this.list = res.data
            this.isShowType = 3
            console.log(data,'data', this.list);
            this.total = res.total_count
            if(this.isInit){
                this.initPage()
                this.isInit = false
            }
        
    })
    }else{
       const params = new URLSearchParams({
        type: this.type,
        page: this.page,
        per_page:this.per_page
    });
    fetch(`${window.location.origin}/api/v3/projects/${this.projectId}/my_action/${this.url}?${params.toString()}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        }})
          .then(response => response.json())
          .then(data => {
            this.list = []
            if(this.url == 'site_diary'){
              this.list = data.list
              this.isShowType = 2
            }else{
              this.list = data.lists
              this.isShowType = 1
            }
            console.log(data,'data', this.list);
            
            this.total = data.total
            if(this.isInit){
                this.initPage()
                this.isInit = false
            }
            
          })
          .catch(error => {
            console.error('Error fetching data:', error)
          });
    }
  }
  showActivity(obj:any){
    this.ActiveName = obj.subject
    this.getActivitiesInfo(obj.id)
  }
  toCheckListDeatail(even:any,e:any){
      const  checkListMap:any = {
      'daily_cleaning': '2',
      'weekly_tidying': '3',
      'weekly_environmental': '4',
      'weekly_safety': '7',
      'monthly_safety': '6',
      'confined_space_works':'12'
    }
    let id = checkListMap[this.type]
    console.log(window.location)
    window.location.href = `${location.origin}${location.pathname}?kind_id=${id}&check_listsID=${even.id}`
  }
  toLabourReturnDeatail(item:any,e:any){
    const pageData = JSON.stringify(item)
    window.sessionStorage.setItem('pageData',pageData)
    const version = this.type == 'labour_returns_v03' ? 'v03' : 'v17'
    const url = location.pathname.replace('/check_lists','/labour_returns')
    console.log(location.pathname,'location.pathname');
    window.location.href = `${location.origin}${url}?version=${version}&pageType=myaction`
  }
  toDeatail(obj:any){
    let arr = ['RISC(inspection)','RISC','RISC(E&M)']
    if(arr.includes(this.type)){
      // 去risc详情页
      console.log('成功');
      window.location.href = `${location.origin}/projects/${this.projectId}/work_packages/${obj.id}/form?pageType=myaction`
    }
  }
  changeType(obj:any){
    this.url = obj.url
    this.type = obj.type
    this.isInit = true
    this.page = 1
    this.getData()
  }
  getActivitiesInfo(Id:any){
    fetch(`${window.location.origin}/api/v3/work_packages/${Id}/activities`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        }})
          .then(response => response.json())
          .then(data => {
            this.embeddedObj = data._embedded
            if(this.embeddedObj.elements.length>0){
              this.titleTime = this.dayjs(this.embeddedObj.elements[0].createdAt).format('YYYY年M月DD日')
              this.embeddedObj.elements.forEach((element:any,index:number) => {
                fetch(`${window.location.origin}${element._links.user.href}`, {
                  method: 'GET',
                  headers: {
                      'Content-Type': 'application/json',
                  }})
                    .then(response => response.json())
                    .then(data => {
                      let text= index== 0?' 创建 ':' 更新于 '
                      element['userData'] = {
                        name:data.name,
                        id:data.id,
                        str:data.name + text + this.dayjs(element.createdAt).format('DD/MM/YYYY HH:mm')
                      }
                      console.log(element,'element');
                      
                    })
                    .catch(error => {
                      console.error('Error fetching data:', error)
                    });             
              });
            }
            if(this.embeddedObj.riscActivtiesLog.length>0){
              this.embeddedObj.riscActivtiesLog.forEach((element:any,index:number) => {
                fetch(`${window.location.origin}${element._links.user.href}`, {
                  method: 'GET',
                  headers: {
                      'Content-Type': 'application/json',
                  }})
                    .then(response => response.json())
                    .then(data => {
                      let text= ' 更新于 '
                      element['userData'] = {
                        name:data.name,
                        id:data.id,
                        str:data.name + text + this.dayjs(element.createdAt).format('DD/MM/YYYY HH:mm')
                      }
                      console.log(element,'element');
                    })
                    .catch(error => {
                      console.error('Error fetching data:', error)
                    });             
              });
            }
            this.isShowActive = true
          })
          .catch(error => {
            console.error('Error fetching data:', error)
          });
  }
  initPage(){
    let self = this
    layui.use('laypage', function(){
        var laypage = layui.laypage;
        //执行一个laypage实例
        laypage.render({
          elem: 'page' //注意，这里的 test1 是 ID，不用加 # 号
          ,count: Number(self.total),
          jump: (obj:any,first:any) => {
            console.log(first,'first');
            console.log(obj)
            self.page = obj.curr
            if(!first){
              self.getData()
            }
          }//数据总数，从服务端得到
        });
      });
  }
  getlistTypeNum(){
    fetch(`${window.location.origin}/api/v3/projects/${this.projectId}/my_action/all_num`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        }})
          .then(response => response.json())
          .then(data => {
           
            this.listType.forEach((item:any) => {
                // 检查 data 对象中是否存在与 typeName 匹配的键
                if (data.hasOwnProperty(item.typeName)) {
                  // 如果存在，则更新 num 属性
                  item.num = data[item.typeName];
                }
              });
            
          })
          .catch(error => {
            console.error('Error fetching data:', error)
          });
  }
  close(){
    this.isShowActive = false
  }
  //偏移位置计算
  private mousePosition(ev: any) {
    if (ev.pageX || ev.pageY) {
      return {
        x: ev.pageX,
        y: ev.pageY,
      };
    }
    return {
      x: ev.clientX + document.body.scrollLeft - document.body.clientLeft - 90,
      y: ev.clientY + document.body.scrollTop - document.body.clientTop - 30,
    };
  }
  //右键点击事件
  public onRightClick(e: any, item: any) {
    const status = item.status && item.status.name ? item.status.name : item.status;

    // 只有状态为 Closed with disapproval 时才显示右键菜单
    if (status !== 'Closed with disapproval') {
      return;
    }

    e.stopPropagation(); //阻止冒泡
    e.preventDefault(); // 阻止默认行为
    var mousePos = this.mousePosition(e);
    this.itemX = mousePos.x;
    this.itemY = mousePos.y;
    this.rightID = item.id;
    this.rightState = status;
    jQuery('#myActionMenu').css('visibility', 'visible');
  }
  //重新提交
  public resubmit() {
    if(this.rightID){
      this.service
      .resubmit({
        obj_id:this.rightID,
        obj_type: "WorkPackage",
      })
      .subscribe((res: any) => {
        if (res.result == "ok") {
          window.location.href = window.location.href;
        } else {
          alert(res.reason);
        }
      });
    }
  }
}
